import { render, staticRenderFns } from "./BedManagementList.vue?vue&type=template&id=3bb28684"
import script from "./BedManagementList.vue?vue&type=script&lang=js"
export * from "./BedManagementList.vue?vue&type=script&lang=js"
import style0 from "./BedManagementList.vue?vue&type=style&index=0&id=3bb28684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports